import { focusIds } from '@/constants/focus'

export const pageFocusId = `${focusIds.SEARCH}${focusIds.CONTAINER_MOD}`
export const focusIdBase = `${focusIds.SEARCH}${focusIds.CONTAINER_MOD}`
export const linesFocusId = `${focusIdBase}_${focusIds.LINES_GROUP}`
export const controlsFocusId = `${focusIdBase}_${focusIds.CONTROLS}`
export const linesGroupFocusId = `${focusIdBase}_${focusIds.LINES_GROUP}`
export const sliderIds = {
  pages: 'searchResultPagesLine',
  events: 'searchResultEventsLine',
}
